__webpack_require__.p = "https://staff-granter.agicap-lab.com/";